<cmps-dialog>
    <cmps-dialog-header [closeTooltip]="_i18n._763_CLOSE | translate">
        <div class="cmps-cdk-font-size-16p cmps-cdk-font-bold">
            {{ _i18n._11221_IMPORT_TRANSCRIPT | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <cmps-wait-status *ngIf="_pending === true"></cmps-wait-status>

        <ng-container *ngIf="_pending !== true">
            <div class="cmps-cdk-font-size-10p cmps-cdk-color-grey-400">
                {{ _i18n._11223_CONFIRMATION_MESSAGE | translate }}
            </div>

            <div class="cmps-cdk-py-1">
                <cmps-radio-group
                    [value]="_items?.[0]?.focusId"
                    #rgRef
                >
                    <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
                        <ng-container *ngFor="let i of _items; let il = last">
                            <div
                                [class.cmps-cdk-border-b-width-1p]="il !== true"
                                [class.cmps-cdk-border-b-solid]="il !== true"
                                [class.cmps-cdk-border-b-color-grey-300]="
                                    il !== true
                                "
                                [class.cmps-cdk-mb-0dot25]="il !== true"
                            >
                                <cmps-radio [value]="i.focusId">
                                    <div>{{ i.behaviourFullName }}</div>
                                    <div>{{ i.subBehaviourFullName }}</div>
                                </cmps-radio>
                            </div>
                        </ng-container>
                    </div>
                </cmps-radio-group>
            </div>

            <div
                class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-align-items-center"
            >
                <div class="cmps-cdk-pr-0dot5">
                    <button
                        class="cmps-button--sm cmps-cdk-bg-color-white cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white"
                        cmpsButton
                        (click)="_onCancelClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._121_CANCEL | translate
                        }}</span>
                    </button>
                </div>
                <div class="cmps-cdk-pr-0dot5">
                    <button
                        class="cmps-button--sm cmps-cdk-bg-color-white cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white"
                        cmpsButton
                        (click)="_onDoNotAssociateClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._11224_DO_NOT_ASSOCIATE | translate
                        }}</span>
                    </button>
                </div>
                <div class="cmps-cdk-pr-0dot5">
                    <button
                        class="cmps-button--sm"
                        cmpsButton
                        [disabled]="_items?.length === 0"
                        (click)="_onAssociateFocusClick(rgRef.value)"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._11225_ASSOCIATE_FOCUS | translate
                        }}</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </cmps-dialog-body>
</cmps-dialog>
